/**
 * iurop-search-panel.js — panel de búsqueda del header (Glucody).
 * Se abre al enfocar el buscador de escritorio o al tocar la lupa en móvil
 * (a pantalla completa); se cierra con la ✕, Esc, clic fuera o la lupa.
 * Apertura/cierre con transición sutil: [hidden] solo marca el estado
 * inicial/no-JS; la animación va por la clase .is-open (visibility+opacity).
 */
(function () {
  'use strict';

  var closeTimer = null;
  var lockedScrollY = null;

  function panel() {
    return document.querySelector('[data-search-panel]');
  }

  // Candado de scroll a prueba de iOS (QA: visión FIJA en móvil): Safari
  // ignora overflow:hidden en html/body y sigue paneando la página de
  // detrás; body position:fixed sí la clava. Solo ≤989 (en escritorio el
  // overflow:hidden del html basta y así no hay salto de scrollbar).
  function lockScroll() {
    if (!window.matchMedia('(max-width: 989px)').matches || lockedScrollY !== null) return;
    lockedScrollY = window.scrollY || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    if (lockedScrollY === null) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    lockedScrollY = null;
  }

  function open() {
    var p = panel();
    if (!p) return;
    clearTimeout(closeTimer);
    if (!p.classList.contains('is-open')) {
      p.hidden = false;
      void p.offsetHeight; // reflow: la transición arranca desde el estado cerrado
      p.classList.add('is-open');
    }
    // el fondo queda bloqueado (en móvil, candado iOS con body fixed)
    document.documentElement.classList.add('glucody-search-open');
    lockScroll();
    var input = p.querySelector('[data-search-panel-input]');
    if (input && window.matchMedia('(max-width: 989px)').matches) input.focus();
  }

  function close() {
    var p = panel();
    if (!p || p.hidden) return;
    p.classList.remove('is-open');
    document.documentElement.classList.remove('glucody-search-open');
    unlockScroll();
    // corta la predictiva pendiente: un debounce/fetch en vuelo llamaba a
    // open() al resolver y el panel se REABRÍA solo tras cerrarlo
    clearTimeout(timer);
    seq++;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { p.hidden = true; }, 220); // tras el fade (0.2s)
  }

  document.addEventListener('focusin', function (e) {
    if (e.target.closest('.glucody-header__search')) open();
  });

  // La lupa (submit) con el buscador VACÍO no debe navegar a /search?q= —
  // abre el panel y enfoca el campo (píldora de escritorio y formulario
  // del panel móvil).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.glucody-header__search, .glucody-header__search-panel-form');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value.trim() === '') {
      e.preventDefault();
      open();
      input.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]')) {
      close();
      return;
    }
    var mobileTrigger = e.target.closest('[data-mobile-search-trigger]');
    if (mobileTrigger) {
      e.preventDefault();
      open();
      var mobileInput = document.querySelector('[data-search-panel-input]');
      if (mobileInput) {
        try { mobileInput.focus({ preventScroll: true }); } catch (err) { mobileInput.focus(); }
      }
      return;
    }
    var lupa = e.target.closest('.glucody-header__action--search-mobile');
    if (lupa) {
      e.preventDefault();
      var p = panel();
      if (p && !p.classList.contains('is-open')) open();
      else close();
      return;
    }
    if (!e.target.closest('[data-search-panel]') && !e.target.closest('.glucody-header__search')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* ------------------------------------------------------------------ */
  /* Búsqueda predictiva (QA, opción A): al teclear se pide la sección   */
  /* iurop-predictive-search por Section Rendering y se inyectan CARDS   */
  /* DE PRODUCTO reales en el hueco de populares/destacados.             */
  /* ------------------------------------------------------------------ */
  var DEBOUNCE_MS = 250;
  var timer = null;
  var seq = 0;

  function partsOf() {
    var p = panel();
    if (!p) return null;
    return {
      box: p.querySelector('[data-search-results]'),
      grid: p.querySelector('[data-search-panel-grid]')
    };
  }

  function showSuggest(show) {
    var el = partsOf();
    if (!el || !el.box) return;
    el.box.hidden = !show;
    if (el.grid) el.grid.hidden = show;
  }

  function fetchResults(q) {
    var mySeq = ++seq;
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    fetch(base + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=iurop-predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mySeq !== seq) return; // respuesta vieja, fuera
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var live = doc.querySelector('.glucody-header__search-live');
        var el = partsOf();
        if (!live || !el || !el.box) return;
        el.box.innerHTML = '';
        el.box.appendChild(live);
        open();
        showSuggest(true);
      })
      .catch(function () { /* red caída → se queda la parrilla */ });
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('.glucody-header__search input[name="q"], [data-search-panel-input]');
    if (!input) return;
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q.length) {
      seq++; // invalida respuestas en vuelo
      showSuggest(false);
      return;
    }
    // populares/destacados fuera desde la primera letra; las cards llegan
    // en ~150ms (los quick-add funcionan por delegación global)
    timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE_MS);
  });
})();
